import { useState, useEffect } from 'react';
import { authApi } from '../api/authApi';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadUserData = async () => {
      setLoading(true);
      const loggedInUser = localStorage.getItem('diploAccessUser');
      const token = localStorage.getItem('diploAccessKey');
      
      if (loggedInUser && token) {
        setUser(loggedInUser);
        
        // Load user profile if we have a token
        try {
          const profile = await authApi.getCurrentUser();
          setUserProfile(profile);
          console.log('User profile loaded on mount:', profile);
          setError(null);
        } catch (error) {
          console.warn('Could not load user profile on mount:', error.message);
          // If token is invalid, clear user data
          if (error.message.includes('401') || error.message.includes('Unauthorized')) {
            localStorage.removeItem('diploAccessKey');
            localStorage.removeItem('diploAccessUser');
            setUser(null);
            setUserProfile(null);
          }
          setError(error.message);
        }
      } else {
        setUser(null);
        setUserProfile(null);
      }
      setLoading(false);
    };
    
    loadUserData();
  }, []);

  const logout = async () => {
    try {
      // Call backend logout
      await authApi.logout();
    } catch (error) {
      console.warn('Backend logout failed:', error.message);
    } finally {
      // Always clear local storage
      localStorage.removeItem('diploAccessKey');
      localStorage.removeItem('diploAccessUser');
      setUser(null);
      setUserProfile(null);
      window.location.reload();
    }
  };

  const refreshUserProfile = async () => {
    try {
      const profile = await authApi.getCurrentUser();
      setUserProfile(profile);
      return profile;
    } catch (error) {
      console.error('Failed to refresh user profile:', error);
      throw error;
    }
  };

  return {
    user,
    userProfile,
    loading,
    error,
    logout,
    refreshUserProfile,
    isAuthenticated: !!user
  };
};
